/*
 * オーダーの案内（トップページ）のパレット
 *
 * 旧テーマ assets/order.js の置き換え。
 * 旧実装は jQuery で、18色ぶん同じ処理が並び、
 * 色・背景色・画像がすべて直書きされていた。
 * ここでは色の数だけ処理を1つ持ち、値はセクションが出力した
 * JSON（背景色・箔の色・商品URL）から読む。
 */
(function () {
  'use strict';

  function init(root) {
    (root || document).querySelectorAll('[data-iroiro-order]').forEach(function (section) {
      if (section.dataset.iroiroReady === 'true') return;
      section.dataset.iroiroReady = 'true';

      var script = section.querySelector('[data-iroiro-order-data]');
      var colors = [];
      try {
        colors = JSON.parse(script.textContent);
      } catch (e) {
        return; // 値が読めないときは何もしない（初期表示のまま）
      }
      if (colors.length === 0) return;

      var rods = section.querySelectorAll('.iroiro-order__rod');
      var photos = section.querySelectorAll('.iroiro-order__photo');
      var button = section.querySelector('.iroiro-btn');

      /*
       * 選んだ棒を列の中央に寄せる。
       *
       * スマホでは棒が画面幅に収まらず横スクロールになる。
       * 選ぶたびに列が動くことで、隠れている色があると気づける。
       * 中央に寄せるのは、動く量を決め打ちにすると
       * 選んだ棒自体が画面の外へ出てしまうことがあるため。
       */
      function reveal(rod, smooth) {
        var rack = rod.parentElement;
        if (rack.scrollWidth <= rack.clientWidth) return; // スクロールできないときは動かさない

        var left = rod.offsetLeft - (rack.clientWidth - rod.offsetWidth) / 2;
        if (rack.scrollTo) {
          rack.scrollTo({ left: left, behavior: smooth ? 'smooth' : 'auto' });
        } else {
          rack.scrollLeft = left;
        }
      }

      function select(index, from) {
        var color = colors[index];
        if (!color) return;

        section.style.setProperty('--iroiro-order-bg', color.bg);

        /*
         * 箔（2色登録）のときだけ背景を箔らしくする。
         * 散らす色は2色目（金なら金、銀なら銀）。
         */
        if (color.foil) {
          section.style.setProperty('--iroiro-order-foil', color.foil);
          section.classList.add('is-foil');
        } else {
          section.classList.remove('is-foil');
        }

        rods.forEach(function (rod) {
          var isCurrent = rod.dataset.index === String(index);
          rod.classList.toggle('is-current', isCurrent);
          rod.setAttribute('aria-pressed', isCurrent ? 'true' : 'false');
        });

        photos.forEach(function (photo) {
          photo.classList.toggle('is-current', photo.dataset.index === String(index));
        });

        /*
         * ボタンは選択中の色の商品ページへ向ける。
         * 商品のURLが取れないときは、設定に入っているリンク先のまま残す。
         */
        if (button && color.url) {
          button.setAttribute('href', color.url);
        }

        /*
         * 読み込み直後に動かすと不自然なので、操作されたときだけ寄せる。
         * スクロールで送っているあいだは、間に合わせるため滑らかにはしない
         * （1色ごとに滑らかな移動が重なると追いつかなくなる）。
         */
        if (from) {
          rods.forEach(function (rod) {
            if (rod.dataset.index === String(index)) reveal(rod, from === 'user');
          });
        }
      }

      var inner = section.querySelector('.iroiro-order-section__inner');

      /*
       * 中身が画面に貼り付いているかどうか。
       * 貼り付いていない幅（スマホ）では色送りもスクロールの移動もしない。
       */
      function isPinned() {
        return !!inner && getComputedStyle(inner).position === 'sticky';
      }

      /* 色送りに使う長さ。取れないときは 0 */
      function holdLength() {
        var hold = parseFloat(getComputedStyle(section).getPropertyValue('--iroiro-order-hold'));
        return hold > 0 ? hold : 0;
      }

      /*
       * 棒は button 要素なので、キーボード操作はブラウザ任せでよい
       * （旧実装は SVG の図形だったため keydown を自前で受けていた）。
       */
      section.addEventListener('click', function (event) {
        var rod = event.target.closest('.iroiro-order__rod');
        if (!rod) return;

        var index = Number(rod.dataset.index);
        select(index, 'user');

        /*
         * 押した色のところまでページを動かす。
         *
         * 以前は「押したら色送りをやめる」という作りだったが、
         * それだと一度押しただけで、そのページを開いているあいだ
         * スクロールでの色送りが戻らなかった。
         *
         * 押した色に対応する位置へスクロールを移してしまえば、
         * そこから先は前後の色へ普通に送られる。
         * fromScroll() の逆算にあたる。
         */
        if (!isPinned()) return;

        var hold = holdLength();
        if (!hold || colors.length < 2) return;

        var top = window.scrollY + section.getBoundingClientRect().top;
        window.scrollTo({
          top: top + (index / (colors.length - 1)) * hold,
          behavior: 'smooth'
        });
      });

      /*
       * スクロールで色を送る。
       *
       * このセクションは中身を画面に貼り付けてあり（iroiro-order.css）、
       * 外側の高さから画面の高さを引いたぶんは見た目が止まって見える。
       * その「止まって見える」区間を色の数で割り当て、
       * スクロール量に応じて1色ずつ送っていく。
       * 最後の色まで来ると貼り付きが外れ、そのまま次のセクションへ流れる。
       *
       * スクロールを妨げてはいない。指を動かせばページは必ず進み、
       * そのあいだ中身が色を変える、という関係にしている。
       */
      var queued = false;
      // 薄くなりきったときの濃さ
      var FADE_TO = 0.3;
      // 覆いの何割の時点で薄くなりきるか
      var FADE_SPAN = 0.5;

      function fromScroll() {
        // 貼り付いていない幅（スマホ）では何もしない
        if (!isPinned()) return;

        /*
         * 送る長さは --iroiro-order-hold から取る。
         * 外側の高さとの差で求めると、次のセクションが覆うぶんまで
         * 含んでしまい、覆われている最中も色が変わり続けてしまう。
         */
        var hold = holdLength();
        if (!hold) return;

        // 上端が画面の上端を通り過ぎた量
        var passed = Math.max(-section.getBoundingClientRect().top, 0);

        var index = Math.round((Math.min(passed, hold) / hold) * (colors.length - 1));
        select(index, 'scroll');

        /*
         * 色を送り終えたあとは、次のセクションが下から覆ってくる区間。
         * そのあいだ、まだ見えている部分を薄くして引かせる。
         *
         * 覆いきるまで1画面ぶんかかるが、薄くなるのはその手前で終わらせる
         * （FADE_SPAN）。覆われるのと同じ速さだと最後まで濃さが残り、
         * 引いていく感じが出ないため。
         */
        var covered = Math.min(Math.max(passed - hold, 0) / (inner.offsetHeight * FADE_SPAN), 1);
        inner.style.opacity = String(1 - covered * (1 - FADE_TO));
      }

      window.addEventListener(
        'scroll',
        function () {
          if (queued) return;
          queued = true;
          requestAnimationFrame(function () {
            queued = false;
            fromScroll();
          });
        },
        { passive: true }
      );

      select(0);
      fromScroll();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  // テーマエディタでセクションを編集し直したときに繋ぎ直す
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
